import React, { useState, useEffect } from 'react';
import { Head, usePage } from '@inertiajs/react';
import { PageProps } from '@/types';
import { Workflow } from '@/types/workflow';
import WorkflowPageLayout from './WorkflowPageLayout';
import WorkflowTable from './Components/WorkflowTable';
import PrimaryButton from '@/Components/PrimaryButton';
import Spinner from '@/Components/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faProjectDiagram, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { getWorkflows, updateWorkflow, deleteWorkflow } from '@/services/workflowService';
import WorkflowFormModal from '@/Pages/Workflow/Components/WorkflowFormModal';
import { useConfirm } from '@/Components/ConfirmDialog';
import toast from 'react-hot-toast';
import Popover from '@/Components/Popover';
import WorkflowExecutionsTable from "@/Pages/Workflow/Components/WorkflowExecutionsTable";

export default function WorkflowsIndex() {
    const { auth } = usePage<PageProps>().props;
    const isPaidUser = !auth.user.is_trial;


    return (
        <>
            <Head title="Workflow Executions">
                <meta name="description" content="View and manage your workflow executions." />
            </Head>
            <WorkflowPageLayout>
                <div className="p-6">
                    <div className="flex flex-row justify-between items-center mb-8 mt-6"><h1 className="text-2xl text-gray-900 dark:text-gray-100">Workflow Executions</h1></div>
                    <WorkflowExecutionsTable/>
                </div>
            </WorkflowPageLayout>
        </>
    );
}
